import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import _toConsumableArray from "/builds/kode-site/career.kode.ru-frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";

function t(t) {
  g.store(t) || v('expect useStore argument to be a store');
  var e = p(N, void 0, t.getState)[1],
      n = d(function () {
    var n = t.updates.watch(function (t) {
      n.active && e(t);
    });
    return n.active = 1, n;
  }, [t]);
  return B(function () {
    return function () {
      n.active = 0, n();
    };
  }, [n]), t.getState();
}

function e(_ref) {
  var e = _ref.store,
      n = _ref.keys,
      o = _ref.fn;
  g.store(e) || v('useStoreMap expects a store'), Array.isArray(n) || v('useStoreMap expects an array as keys'), 'function' != typeof o && v('useStoreMap expects a function');
  var r = d(function () {
    return k(o(e.getState(), n)).on(e, function (t, e) {
      return o(e, n);
    });
  }, n),
      s = t(r);
  return B(function () {
    return function () {
      r.off(e), b(r, {
        deep: 1
      });
    };
  }, n), s;
}

function n(t, e) {
  return e.displayName = t, e;
}

function o(e, o) {
  function r(e) {
    var n = y(e),
        r = d(function () {
      return f(e);
    }, []),
        s = t(r);
    B(function () {
      return u({
        props: n.current,
        state: r.getState()
      }), function () {
        i({
          props: n.current,
          state: r.getState()
        });
      };
    }, []);
    var c = o(e, s);
    return n.current = e, c;
  }

  var s, c;
  g.store(e) ? c = e : 'function' == typeof e ? s = e : 'object' == typeof e && null !== e ? c = S(e) : v('shape should be a store or object with stores');
  var a = 'Unknown';
  c && c.shortName && (a = c.shortName);
  var u = x("".concat(a, ".View mounted")),
      i = x("".concat(a, ".View unmounted")),
      f = 'function' == typeof e ? s : function () {
    return c;
  };
  return r.mounted = u, r.unmounted = i, n("".concat(a, ".View"), r);
}

function r(t) {
  return o(t, function (_ref2, e) {
    var t = _ref2.children;
    return t(e);
  });
}

function s(t, o) {
  var r,
      s = [];
  'object' == typeof o && null !== o ? (o.keys && (s = o.keys), r = o.fn) : r = o, g.store(t) || v('expect useList first argument to be a store'), 'function' != typeof r && v("expect useList's renderItem to be a function"), Array.isArray(s) || v("expect useList's keys to be an array");
  var c = d(function () {
    var o = n("".concat(t.shortName || 'Unknown', ".Item"), function (_ref3) {
      var n = _ref3.index,
          o = _ref3.keys;
      var r = e({
        store: t,
        keys: [n].concat(_toConsumableArray(o)),
        fn: function fn(t, e) {
          return t[e[0]];
        }
      });
      return u.current(r, n);
    });
    return h(o);
  }, [t]),
      a = e({
    store: t,
    keys: [t],
    fn: function fn(t) {
      return t.length;
    }
  }),
      u = y(r);
  u.current = r;
  var i = d(function () {
    return s;
  }, s);
  return Array.from({
    length: a
  }, function (t, e) {
    return w(c, {
      index: e,
      key: e,
      keys: i
    });
  });
}

function c(e, o) {
  return n("Connect(".concat(o.displayName || o.name || 'Unknown', ")"), function (n) {
    return w(o, Object.assign({}, n, t(e)));
  });
}

function a(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var n = y(null);
  B(function () {
    return t.open(n.current), function () {
      return t.close(n.current);
    };
  }, [t]), function (t, e) {
    if (t === e) return 1;

    if ('object' == typeof t && null !== t && 'object' == typeof e && null !== e) {
      var _n = Object.keys(t),
          _o = Object.keys(e);

      if (_n.length !== _o.length) return 0;

      for (var _o2 = 0; _o2 < _n.length; _o2++) {
        var _r = _n[_o2];
        if (t[_r] !== e[_r]) return 0;
      }

      return 1;
    }

    return 0;
  }(n.current, e) || (n.current = e, t.set(e));
}

function u() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "gate";
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  function o(t) {
    return a(o, t), null;
  }

  var r;
  'object' == typeof t && null !== t && ('defaultState' in t && (e = t.defaultState), t.domain && (r = t.domain), t = t.name || 'gate');

  var s = k(Boolean(0)),
      c = k(e),
      _j = j(c, {
    set: function set(t, e) {
      return e;
    }
  }),
      i = _j.set,
      _j2 = j(s, {
    open: function open() {
      return o.predicate() && Boolean(1);
    },
    close: function close() {
      return Boolean(0);
    },
    destructor: function destructor() {
      return Boolean(0);
    }
  }),
      f = _j2.open,
      l = _j2.close,
      p = _j2.destructor;

  o.predicate = function () {
    return Boolean(1);
  }, o.isOpen = Boolean(0), o.current = c.getState(), o.open = f, o.close = l, o.status = s, o.state = c, o.set = i, o.destructor = p, o.isTerminated = Boolean(0), o.childGate = function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Subgate";
    console.error('childGate is deprecated');
    var n = u("".concat(t, "/").concat(e));

    n.predicate = function () {
      return o.status.getState();
    };

    var r = 0,
        s = 0;
    return n.open.watch(function () {
      s || (r = 1);
    }), n.close.watch(function () {
      s || (r = 0);
    }), o.status.watch(function (t) {
      s = 1, r && t && !n.status.getState() && n.open(), s = 0;
    }), o.close.watch(function () {
      s = 1, n.close(), s = 0;
    }), o.destructor.watch(function () {
      return n.destructor();
    }), n;
  };
  var d = s.watch(function (t) {
    return o.isOpen = t;
  }),
      y = c.watch(function (t) {
    return o.current = t;
  });
  s.map(function (t) {
    return t || (o.current = e), null;
  }), c.reset(l);
  var m = p.watch(function () {
    o.isTerminated = Boolean(1);
  }),
      h = p.watch(function () {
    h(), d(), y(), m(), o.status.off(o.open), o.status.off(o.close), o.status.off(o.destructor), o.state.off(o.set);
  });

  if (r) {
    var _r2 = r,
        _t = _r2.hooks;
    $({
      target: [_t.store, _t.store, _t.event, _t.event, _t.event],
      params: [s, c, f, l, i]
    });
  }

  return n("Gate:".concat(t), o);
}

function i(t) {
  return t;
}

import { useLayoutEffect as f, useEffect as l, useReducer as p, useMemo as d, useRef as y, useContext as m, memo as h, createElement as w } from 'react';
import { is as g, createStore as k, clearNode as b, combine as S, createEvent as x, createApi as j, launch as $ } from 'effector';

var B = 'undefined' != typeof window ? f : l,
    v = function v(t) {
  throw Error(t);
},
    N = function N(t, e) {
  return e;
},
    A = function A(e, o, r) {
  return n("".concat(e.shortName || 'Unknown', ".ContextComponent"), function (n) {
    var s = m(o),
        c = t(e);
    return r(n, c, s);
  });
},
    O = function O(t) {
  return function (e) {
    return c(e, t);
  };
};

export { O as connect, o as createComponent, A as createContextComponent, u as createGate, c as createReactState, r as createStoreConsumer, i as useEvent, a as useGate, s as useList, t as useStore, e as useStoreMap };